'use client';

import { useEffect, useRef } from 'react';
import Link from 'next/link';

const services = [
  {
    id: 'screen',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:10:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="10" data-component-end-line="22" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect data-component-id="src/components/ServicesGrid.tsx:20:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="20" data-component-end-line="20" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="5" y="2" width="14" height="20" rx="2" ry="2" />
        <line data-component-id="src/components/ServicesGrid.tsx:21:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="21" data-component-end-line="21" data-component-file="ServicesGrid.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="12" y1="18" x2="12.01" y2="18" />
      </svg>
    ),
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
    title: 'Screen Repair',
    tagline: 'Cracked or Shattered Display',
    description:
      'We replace cracked, shattered, and unresponsive screens for all major smartphone brands. We use OEM-quality displays that restore full touch sensitivity, brightness, and colour accuracy.',
    brands: [
      'All iPhones',
      'Samsung S/A Series',
      'Google Pixel',
      'OnePlus',
      'Mototrola',
      'Most Android',
    ],
    prices: [
      { model: 'iPhone 14 / 14 Plus', price: '$120 - $170' },
      { model: 'iPhone 13 / 13 Pro', price: '$110 - $125' },
      { model: 'Samsung Galaxy S24 Ultra', price: '$400 - $450' },
      { model: 'Google Pixel 7', price: '$260 - $280' },
    ],
    startingPrice: '$90',
    time: '1 - 2 hours',
    warranty: '60 days',
    popular: true,
  },
  {
    id: 'battery',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:52:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="52" data-component-end-line="65" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect data-component-id="src/components/ServicesGrid.tsx:62:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="62" data-component-end-line="62" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="2" y="7" width="16" height="10" rx="2" ry="2" />
        <line data-component-id="src/components/ServicesGrid.tsx:63:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="63" data-component-end-line="63" data-component-file="ServicesGrid.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="22" y1="11" x2="22" y2="13" />
        <line data-component-id="src/components/ServicesGrid.tsx:64:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="64" data-component-end-line="64" data-component-file="ServicesGrid.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="6" y1="12" x2="10" y2="12" />
      </svg>
    ),
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
    title: 'Battery Replacement',
    tagline: 'Restore All-Day Battery Life',
    description:
      "If your phone is draining in a few hours, shutting down unexpectedly, or not charging past 80%, it's time for a new battery. We install high-capacity, OEM-equivalent cells.",
    brands: ['All iPhones', 'Samsung Galaxy', 'Google Pixel', 'Most Android'],
    prices: [
      { model: 'iPhone 14 Series', price: '$90' },
      { model: 'iPhone 12 / 13', price: '$80' },
      { model: 'Samsung Galaxy S23', price: '$85' },
      { model: 'Google Pixel 7/8', price: '$90' },
    ],
    startingPrice: '$60',
    time: '45 minutes - 1 hours',
    warranty: '60 days',
    popular: false,
  },
  {
    id: 'charging',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:88:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="88" data-component-end-line="99" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path data-component-id="src/components/ServicesGrid.tsx:98:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="98" data-component-end-line="98" data-component-file="ServicesGrid.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
      </svg>
    ),
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
    title: 'Charging Port Fix',
    tagline: "Won\'t Charge or Charges Slowly",
    description:
      'Lint, debris, and normal wear can damage your charging port. We clean, repair, or replace USB-C, Lightning, and Micro-USB ports. Most fixes are done in under 60 minutes.',
    brands: [
      'All iPhones',
      'All Android',
      'USB-C Devices',
      'Lightning Devices',
      'Micro-USB Devices',
    ],
    prices: [
      { model: 'iPhone (Lightning)', price: '$70 - $120' },
      { model: 'iPhone 15+ (USB-C)', price: '$120 - $150' },
      { model: 'Samsung (USB-C)', price: '$70 - $120' },
      { model: 'Other Android', price: '$70 - $100' },
    ],
    startingPrice: '$70',
    time: '45 - 90 minutes',
    warranty: '60 days',
    popular: false,
  },
  {
    id: 'camera',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:128:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="128" data-component-end-line="140" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path data-component-id="src/components/ServicesGrid.tsx:138:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="138" data-component-end-line="138" data-component-file="ServicesGrid.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
        <circle data-component-id="src/components/ServicesGrid.tsx:139:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="139" data-component-end-line="139" data-component-file="ServicesGrid.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="12" cy="13" r="4" />
      </svg>
    ),
    color: '#8B5CF6',
    bg: 'rgba(139, 92, 246, 0.1)',
    title: 'Camera Repair',
    tagline: 'Blurry Photos or Camera Not Working',
    description:
      "We replace front selfie cameras and rear camera modules. Whether your lens is cracked, the autofocus is broken, or the camera app won't open - we diagnose and fix it.",
    brands: ['All iPhone', 'Samsung S/A Series', 'Google Pixel', 'OnePlus', 'Most Android'],
    prices: [
      { model: 'iPhone Rear Camera', price: '$90 - $150' },
      { model: 'iPhone Front Camera', price: '$70 - $120' },
      { model: 'Samsung Rear Module', price: '$85 - $150' },
      { model: 'Pixel Camera', price: '$79 - $120' },
    ],
    startingPrice: '$65',
    time: '1 - 2 hours',
    warranty: '60 days',
    popular: false,
  },
  {
    id: 'software',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:163:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="163" data-component-end-line="175" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline data-component-id="src/components/ServicesGrid.tsx:173:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="173" data-component-end-line="173" data-component-file="ServicesGrid.tsx" data-component-name="polyline" data-component-content="%7B%22elementName%22%3A%22polyline%22%7D" points="16 18 22 12 16 6" />
        <polyline data-component-id="src/components/ServicesGrid.tsx:174:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="174" data-component-end-line="174" data-component-file="ServicesGrid.tsx" data-component-name="polyline" data-component-content="%7B%22elementName%22%3A%22polyline%22%7D" points="8 6 2 12 8 18" />
      </svg>
    ),
    color: '#EC4899',
    bg: 'rgba(236, 72, 153, 0.1)',
    title: 'Software Issues',
    tagline: 'Frozen, Slow, or Boot Loop',
    description:
      'We diagnose and resolve iOS and Android software problems including boot loops, factory resets, iOS/Android OS updates, malware removal, and data recovery attempts.',
    brands: ['All iPhones', 'All Android', 'iOS & Android', 'Data Recovery', 'Virus Removal'],
    prices: [
      { model: 'Factory Reset + Setup', price: '$90' },
      { model: 'iOS/Android Update Fix', price: '$50' },
      { model: 'Malware / Virus Removal', price: '$49' },
    ],
    startingPrice: '$39',
    time: '30 - 90 minutes',
    warranty: '30 days',
    popular: false,
  },
  {
    id: 'laptop-screen',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:197:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="197" data-component-end-line="209" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect data-component-id="src/components/ServicesGrid.tsx:207:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="207" data-component-end-line="207" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="2" y="4" width="20" height="12" rx="2" />
        <line data-component-id="src/components/ServicesGrid.tsx:208:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="208" data-component-end-line="208" data-component-file="ServicesGrid.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="2" y1="20" x2="22" y2="20" />
      </svg>
    ),
    color: '#0EA5E9',
    bg: 'rgba(14, 165, 233, 0.1)',
    title: 'Laptop Screen Repair',
    tagline: 'Cracked or Flickering Display',
    description:
      'We replace broken, flickering, and black laptop screens for most major brands. High-quality panels with proper brightness and resolution.',
    brands: ['HP', 'Dell', 'Lenovo', 'Acer', 'ASUS', 'Most Windows Laptops'],
    prices: [
      { model: 'Standard 14" / 15.6"', price: '$120 - $180' },
      { model: 'Touchscreen Models', price: '$180 - $280' },
      { model: 'Premium / Slim Models', price: '$200 - $350' },
    ],
    startingPrice: '$120',
    time: '1 - 3 hours',
    warranty: '60 days',
    popular: true,
  },
  {
    id: 'laptop-battery',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:231:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="231" data-component-end-line="243" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect data-component-id="src/components/ServicesGrid.tsx:241:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="241" data-component-end-line="241" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="2" y="7" width="16" height="10" rx="2" />
        <line data-component-id="src/components/ServicesGrid.tsx:242:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="242" data-component-end-line="242" data-component-file="ServicesGrid.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="22" y1="11" x2="22" y2="13" />
      </svg>
    ),
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
    title: 'Laptop Battery Replacement',
    tagline: 'Not Holding Charge',
    description:
      'If your laptop battery drains quickly or shuts down unexpectedly, we install high-quality compatible replacement batteries.',
    brands: ['HP', 'Dell', 'Lenovo', 'ASUS', 'Acer'],
    prices: [
      { model: 'Standard Models', price: '$90 - $140' },
      { model: 'Internal Built-in Batteries', price: '$120 - $180' },
    ],
    startingPrice: '$90',
    time: '1 - 2 hours',
    warranty: '60 days',
    popular: false,
  },
  {
    id: 'storage-upgrade',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:264:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="264" data-component-end-line="276" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect data-component-id="src/components/ServicesGrid.tsx:274:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="274" data-component-end-line="274" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="3" y="4" width="18" height="16" rx="2" />
        <line data-component-id="src/components/ServicesGrid.tsx:275:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="275" data-component-end-line="275" data-component-file="ServicesGrid.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
    color: '#F59E0B',
    bg: 'rgba(245, 158, 11, 0.1)',
    title: 'SSD / Storage Upgrade',
    tagline: 'Boost Speed & Performance',
    description:
      'Upgrade your laptop to a fast SSD for improved speed and reliability. Includes installation and Windows setup if required.',
    brands: ['All Windows Laptops'],
    prices: [
      { model: '256GB SSD Install', price: '$120 - $160' },
      { model: '512GB SSD Install', price: '$150 - $200' },
      { model: '1TB SSD Install', price: '$180 - $250' },
    ],
    startingPrice: '$120',
    time: '1 - 2 hours',
    warranty: '60 days',
    popular: false,
  },
  {
    id: 'data-transfer',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:298:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="298" data-component-end-line="310" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline data-component-id="src/components/ServicesGrid.tsx:308:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="308" data-component-end-line="308" data-component-file="ServicesGrid.tsx" data-component-name="polyline" data-component-content="%7B%22elementName%22%3A%22polyline%22%7D" points="7 7 12 12 7 17" />
        <polyline data-component-id="src/components/ServicesGrid.tsx:309:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="309" data-component-end-line="309" data-component-file="ServicesGrid.tsx" data-component-name="polyline" data-component-content="%7B%22elementName%22%3A%22polyline%22%7D" points="17 7 12 12 17 17" />
      </svg>
    ),
    color: '#8B5CF6',
    bg: 'rgba(139, 92, 246, 0.1)',
    title: 'Data Transfer & Backup',
    tagline: 'Move Files Safely',
    description:
      'We securely transfer your files from old laptops to new devices or external drives. Includes backup setup and organization.',
    brands: ['Windows & External Drives'],
    prices: [
      { model: 'Basic Transfer', price: '$50 - $80' },
      { model: 'Large Data Migration', price: '$90 - $150' },
    ],
    startingPrice: '$50',
    time: '30 - 90 minutes',
    warranty: 'Service-based',
    popular: false,
  },
  {
    id: 'windows-install',
    icon: (
      <svg data-component-id="src/components/ServicesGrid.tsx:331:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="331" data-component-end-line="345" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect data-component-id="src/components/ServicesGrid.tsx:341:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="341" data-component-end-line="341" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="3" y="3" width="8" height="8" />
        <rect data-component-id="src/components/ServicesGrid.tsx:342:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="342" data-component-end-line="342" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="13" y="3" width="8" height="8" />
        <rect data-component-id="src/components/ServicesGrid.tsx:343:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="343" data-component-end-line="343" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="3" y="13" width="8" height="8" />
        <rect data-component-id="src/components/ServicesGrid.tsx:344:8" data-component-path="src/components/ServicesGrid.tsx" data-component-line="344" data-component-end-line="344" data-component-file="ServicesGrid.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="13" y="13" width="8" height="8" />
      </svg>
    ),
    color: '#EC4899',
    bg: 'rgba(236, 72, 153, 0.1)',
    title: 'Windows Installation',
    tagline: 'Fresh OS Setup & Optimization',
    description:
      'Clean Windows installation with drivers, updates, and system optimization for smooth performance.',
    brands: ['Windows Laptops'],
    prices: [
      { model: 'Windows Install + Drivers', price: '$90' },
      { model: 'Windows + Basic Software Setup', price: '$120' },
    ],
    startingPrice: '$90',
    time: '1 - 2 hours',
    warranty: '30 days',
    popular: false,
  },
];

export default function ServicesGrid() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.08 }
    );
    const elements = sectionRef?.current?.querySelectorAll('.reveal, .reveal-scale');
    elements?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section data-component-id="src/components/ServicesGrid.tsx:383:4" data-component-path="src/components/ServicesGrid.tsx" data-component-line="383" data-component-end-line="609" data-component-file="ServicesGrid.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-24%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D"
      ref={sectionRef}
      className="py-24 px-4 sm:px-6 lg:px-8"
      style={{ background: '#F8FAFF' }}
    >
      <div data-component-id="src/components/ServicesGrid.tsx:388:6" data-component-path="src/components/ServicesGrid.tsx" data-component-line="388" data-component-end-line="608" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20space-y-8%22%7D" className="max-w-7xl mx-auto space-y-8">
        {services?.map((service, i) => (
          <div data-component-id="src/components/ServicesGrid.tsx:390:10" data-component-path="src/components/ServicesGrid.tsx" data-component-line="390" data-component-end-line="606" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
            key={service?.id}
            id={service?.id}
            className={`service-card p-0 overflow-hidden reveal ${i % 2 === 0 ? 'reveal-left' : 'reveal-right'}`}
            style={{ transitionDelay: `${i * 0.05}s` }}
          >
            <div data-component-id="src/components/ServicesGrid.tsx:396:12" data-component-path="src/components/ServicesGrid.tsx" data-component-line="396" data-component-end-line="605" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`grid lg:grid-cols-5 gap-0 ${i % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`}
            >
              {/* Left: Main Info */}
              <div data-component-id="src/components/ServicesGrid.tsx:400:14" data-component-path="src/components/ServicesGrid.tsx" data-component-line="400" data-component-end-line="554" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-3%20p-8%20sm%3Ap-10%22%7D" className="lg:col-span-3 p-8 sm:p-10">
                <div data-component-id="src/components/ServicesGrid.tsx:401:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="401" data-component-end-line="465" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20justify-between%20flex-wrap%20gap-4%20mb-6%22%7D" className="flex items-start justify-between flex-wrap gap-4 mb-6">
                  <div data-component-id="src/components/ServicesGrid.tsx:402:18" data-component-path="src/components/ServicesGrid.tsx" data-component-line="402" data-component-end-line="446" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-4%22%7D" className="flex items-center gap-4">
                    <div data-component-id="src/components/ServicesGrid.tsx:403:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="403" data-component-end-line="408" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-16%20h-16%20rounded-2xl%20flex%20items-center%20justify-center%20flex-shrink-0%22%7D"
                      className="w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0"
                      style={{ background: service?.bg, color: service?.color }}
                    >
                      {service?.icon}
                    </div>
                    <div data-component-id="src/components/ServicesGrid.tsx:409:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="409" data-component-end-line="445" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
                      <div data-component-id="src/components/ServicesGrid.tsx:410:22" data-component-path="src/components/ServicesGrid.tsx" data-component-line="410" data-component-end-line="434" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%20flex-wrap%22%7D" className="flex items-center gap-2 flex-wrap">
                        <h2 data-component-id="src/components/ServicesGrid.tsx:411:24" data-component-path="src/components/ServicesGrid.tsx" data-component-line="411" data-component-end-line="420" data-component-file="ServicesGrid.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-2xl%20font-heading%20font-800%22%7D"
                          className="text-2xl font-heading font-800"
                          style={{
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontWeight: 800,
                            color: '#1A1F2E',
                          }}
                        >
                          {service?.title}
                        </h2>
                        {service?.popular && (
                          <span data-component-id="src/components/ServicesGrid.tsx:422:26" data-component-path="src/components/ServicesGrid.tsx" data-component-line="422" data-component-end-line="432" data-component-file="ServicesGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22px-3%20py-1%20rounded-full%20text-xs%20font-heading%20font-700%22%2C%22textContent%22%3A%22Most%20Popular%22%7D"
                            className="px-3 py-1 rounded-full text-xs font-heading font-700"
                            style={{
                              background: 'linear-gradient(135deg, #FF6F00, #FF9A3C)',
                              color: 'white',
                              fontFamily: "'Plus Jakarta Sans', sans-serif",
                              fontWeight: 700,
                            }}
                          >
                            Most Popular
                          </span>
                        )}
                      </div>
                      <p data-component-id="src/components/ServicesGrid.tsx:435:22" data-component-path="src/components/ServicesGrid.tsx" data-component-line="435" data-component-end-line="444" data-component-file="ServicesGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%22%7D"
                        className="text-sm"
                        style={{
                          color: service?.color,
                          fontFamily: "'DM Sans', sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        {service?.tagline}
                      </p>
                    </div>
                  </div>
                  <div data-component-id="src/components/ServicesGrid.tsx:447:18" data-component-path="src/components/ServicesGrid.tsx" data-component-line="447" data-component-end-line="464" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-right%22%7D" className="text-right">
                    <div data-component-id="src/components/ServicesGrid.tsx:448:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="448" data-component-end-line="457" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-3xl%20font-heading%20font-800%22%7D"
                      className="text-3xl font-heading font-800"
                      style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontWeight: 800,
                        color: '#1A1F2E',
                      }}
                    >
                      {service?.startingPrice}
                    </div>
                    <p data-component-id="src/components/ServicesGrid.tsx:458:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="458" data-component-end-line="463" data-component-file="ServicesGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%22%2C%22textContent%22%3A%22starting%20price%22%7D"
                      className="text-xs"
                      style={{ color: '#9CA3AF', fontFamily: "'DM Sans', sans-serif" }}
                    >
                      starting price
                    </p>
                  </div>
                </div>

                <p data-component-id="src/components/ServicesGrid.tsx:467:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="467" data-component-end-line="472" data-component-file="ServicesGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-base%20leading-relaxed%20mb-6%22%7D"
                  className="text-base leading-relaxed mb-6"
                  style={{ color: '#4B5563', fontFamily: "'DM Sans', sans-serif" }}
                >
                  {service?.description}
                </p>

                {/* Meta info */}
                <div data-component-id="src/components/ServicesGrid.tsx:475:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="475" data-component-end-line="513" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-4%20mb-6%22%7D" className="flex flex-wrap gap-4 mb-6">
                  {[
                    {
                      icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
                      label: `${service?.warranty} warranty`,
                    },
                    {
                      icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M12 8v4 M12 16h.01',
                      label: service?.time,
                    },
                    { icon: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z', label: 'Home service' },
                  ]?.map((meta) => (
                    <div data-component-id="src/components/ServicesGrid.tsx:487:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="487" data-component-end-line="511" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-1.5%22%7D" key={meta.label} className="flex items-center gap-1.5">
                      <div data-component-id="src/components/ServicesGrid.tsx:488:22" data-component-path="src/components/ServicesGrid.tsx" data-component-line="488" data-component-end-line="504" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-6%20h-6%20rounded-lg%20flex%20items-center%20justify-center%22%7D"
                        className="w-6 h-6 rounded-lg flex items-center justify-center"
                        style={{ background: service?.bg }}
                      >
                        <svg data-component-id="src/components/ServicesGrid.tsx:492:24" data-component-path="src/components/ServicesGrid.tsx" data-component-line="492" data-component-end-line="503" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={service?.color}
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path data-component-id="src/components/ServicesGrid.tsx:502:26" data-component-path="src/components/ServicesGrid.tsx" data-component-line="502" data-component-end-line="502" data-component-file="ServicesGrid.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d={meta.icon} />
                        </svg>
                      </div>
                      <span data-component-id="src/components/ServicesGrid.tsx:505:22" data-component-path="src/components/ServicesGrid.tsx" data-component-line="505" data-component-end-line="510" data-component-file="ServicesGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%22%7D"
                        className="text-xs"
                        style={{ color: '#6B7280', fontFamily: "'DM Sans', sans-serif" }}
                      >
                        {meta.label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Compatible brands */}
                <div data-component-id="src/components/ServicesGrid.tsx:516:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="516" data-component-end-line="530" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-2%20mb-8%22%7D" className="flex flex-wrap gap-2 mb-8">
                  {service?.brands?.map((brand) => (
                    <span data-component-id="src/components/ServicesGrid.tsx:518:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="518" data-component-end-line="528" data-component-file="ServicesGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22px-3%20py-1%20rounded-full%20text-xs%20font-body%22%7D"
                      key={brand}
                      className="px-3 py-1 rounded-full text-xs font-body"
                      style={{
                        background: '#F1F5F9',
                        color: '#374151',
                        fontFamily: "'DM Sans', sans-serif",
                      }}
                    >
                      {brand}
                    </span>
                  ))}
                </div>

                <Link data-component-id="src/components/ServicesGrid.tsx:532:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="532" data-component-end-line="553" data-component-file="ServicesGrid.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fbook-repair%22%2C%22className%22%3A%22btn-primary%20text-sm%22%2C%22textContent%22%3A%22Book%22%7D"
                  href="/book-repair"
                  className="btn-primary text-sm"
                  style={{
                    background: `linear-gradient(135deg, ${service?.color}, ${service?.color}CC)`,
                    boxShadow: `0 4px 16px ${service?.color}40`,
                  }}
                >
                  <svg data-component-id="src/components/ServicesGrid.tsx:540:18" data-component-path="src/components/ServicesGrid.tsx" data-component-line="540" data-component-end-line="551" data-component-file="ServicesGrid.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path data-component-id="src/components/ServicesGrid.tsx:550:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="550" data-component-end-line="550" data-component-file="ServicesGrid.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013 12.79 19.79 19.79 0 01.21 4.18 2 2 0 012.18 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                  </svg>
                  Book {service?.title}
                </Link>
              </div>

              {/* Right: Pricing Table */}
              <div data-component-id="src/components/ServicesGrid.tsx:557:14" data-component-path="src/components/ServicesGrid.tsx" data-component-line="557" data-component-end-line="604" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-2%20p-8%20sm%3Ap-10%20flex%20flex-col%20justify-center%22%7D"
                className="lg:col-span-2 p-8 sm:p-10 flex flex-col justify-center"
                style={{ background: '#F8FAFF', borderLeft: '1px solid #E5E9F2' }}
              >
                <h4 data-component-id="src/components/ServicesGrid.tsx:561:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="561" data-component-end-line="570" data-component-file="ServicesGrid.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22text-sm%20font-heading%20font-700%20uppercase%20tracking-widest%20mb-6%22%2C%22textContent%22%3A%22Sample%20Pricing%22%7D"
                  className="text-sm font-heading font-700 uppercase tracking-widest mb-6"
                  style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontWeight: 700,
                    color: '#9CA3AF',
                  }}
                >
                  Sample Pricing
                </h4>
                <div data-component-id="src/components/ServicesGrid.tsx:571:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="571" data-component-end-line="596" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-3%22%7D" className="space-y-3">
                  {service?.prices?.map((item) => (
                    <div data-component-id="src/components/ServicesGrid.tsx:573:20" data-component-path="src/components/ServicesGrid.tsx" data-component-line="573" data-component-end-line="594" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20py-3%20px-4%20rounded-xl%20transition-all%20hover%3Ashadow-sm%22%7D"
                      key={item?.model}
                      className="flex items-center justify-between py-3 px-4 rounded-xl transition-all hover:shadow-sm"
                      style={{ background: 'white', border: '1px solid #E5E9F2' }}
                    >
                      <span data-component-id="src/components/ServicesGrid.tsx:578:22" data-component-path="src/components/ServicesGrid.tsx" data-component-line="578" data-component-end-line="583" data-component-file="ServicesGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%22%7D"
                        className="text-sm"
                        style={{ color: '#374151', fontFamily: "'DM Sans', sans-serif" }}
                      >
                        {item?.model}
                      </span>
                      <span data-component-id="src/components/ServicesGrid.tsx:584:22" data-component-path="src/components/ServicesGrid.tsx" data-component-line="584" data-component-end-line="593" data-component-file="ServicesGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-heading%20font-700%20text-sm%22%7D"
                        className="font-heading font-700 text-sm"
                        style={{
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 700,
                          color: service?.color,
                        }}
                      >
                        {item?.price}
                      </span>
                    </div>
                  ))}
                </div>
                <p data-component-id="src/components/ServicesGrid.tsx:597:16" data-component-path="src/components/ServicesGrid.tsx" data-component-line="597" data-component-end-line="603" data-component-file="ServicesGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20mt-4%22%2C%22textContent%22%3A%22*%20Prices%20vary%20by%20model.%20Free%20diagnosis%20included.%20Final%20quote%20given%20before%20repair%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20begins.%22%7D"
                  className="text-xs mt-4"
                  style={{ color: '#9CA3AF', fontFamily: "'DM Sans', sans-serif" }}
                >
                  * Prices vary by model. Free diagnosis included. Final quote given before repair
                  begins.
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
